import { Mail } from 'lucide-react';
import { getCloudinaryUrl } from '../utils/cloudinary';
import { PageHeader } from './PageHeader';
import { BAND_EMAIL } from '../constants/contact';

const cardData = [
    { content: 'Northwoods Jam Music Festival 2023', image: 'show-northwoods-2023.jpg' },
    { title: 'Opening for Ray Scott', content: 'Ryders Saloon 2023', image: 'show-rayscott.jpg' },
    {
        title: "Opening for Devon Worley's Album Release Show",
        content: 'Amsterdam Bar & Hall 2023',
        image: 'show-devonworley.jpg',
    },
    { title: 'Opening for Matt Pudas', content: 'Ryders Saloon 2023', image: 'show-mattpudas.jpg' },
    { content: 'Northwoods Jam Music Festival 2022', image: 'show-northwoods-2022.jpg' },
    {
        title: 'Show w/Devon Worley & Russ Parrish',
        content: "First Ave's 7th Street Entry 2024",
        image: 'show-seventhstreet.jpg',
    },
];

export function EPKPage() {
    const handleEmailClick = () => {
        window.location.href = `mailto:${BAND_EMAIL}`;
    };

    return (
        <div className="w-full max-w-6xl mx-auto px-4 py-8 space-y-12">
            <PageHeader title="Press Kit" className="px-0" />

            {/* Short Bio Section */}
            <div className="space-y-4">
                <h2 className="text-2xl md:text-3xl font-bold uppercase text-primary">Short Bio</h2>
                <p className="text-foreground text-base leading-8">
                    The Samuel John Band is a dynamic country rock ensemble rooted in the heart of Minnesota. Hailing
                    from the small town of Braham, MN, Samuel John found his musical calling through the inspiring
                    performances of his mother, a pianist and vocalist, and witnessing his brother Ben drum for a
                    touring country band. Samuel, also a frequent concert-goer, drew inspiration from watching his
                    favorite songwriters in the independent country and rock scene. Joined by longtime friend Jake Abel
                    on bass, whose experience spans multiple bands, and meeting Brandon Nelson, the lead guitarist,
                    through spontaneous jams at the Monday night Terminal Bar open sessions in Minneapolis, the band
                    found its core. John Wander, previously collaborating with Brandon, completed the lineup on drums.
                    Together, they're doing their best to create an authentic and original country rock sound.
                </p>
            </div>

            {/* Email Button */}
            <button
                onClick={handleEmailClick}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-background font-semibold uppercase tracking-wider hover:opacity-90 transition-opacity rounded"
            >
                <Mail className="w-5 h-5" />
                {BAND_EMAIL}
            </button>

            {/* Debut Single Section */}
            <div className="space-y-4">
                <h2 className="text-2xl md:text-3xl font-bold uppercase text-primary">
                    Our Debut Single "Set Me Free" out now!
                </h2>
                <div className="rounded-lg overflow-hidden">
                    <iframe
                        title="Set Me Free on Spotify"
                        style={{ borderRadius: 12 }}
                        src="https://open.spotify.com/embed/track/3lSYVJNuJnV4zZtFUEIeV2?utm_source=generator&theme=0"
                        width="100%"
                        height="352"
                        frameBorder="0"
                        allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                        loading="lazy"
                    ></iframe>
                </div>
            </div>

            {/* YouTube Videos */}
            <div className="space-y-4">
                <h2 className="text-2xl md:text-3xl font-bold uppercase text-primary mb-6">Featured Videos</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                        <iframe
                            title="Set Me Free at RiverRock Studios"
                            src="https://www.youtube.com/embed/vsXaqSLnHg4?si=rThIch0XsGbgNGCN"
                            frameBorder="0"
                            allowFullScreen
                            style={{
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                width: '100%',
                                height: '100%',
                            }}
                        ></iframe>
                    </div>
                    <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                        <iframe
                            title="Set Me Free Live at Northwoods Jam 2023"
                            src="https://www.youtube.com/embed/BajXVOTdKls?si=7C5J0voaBwjlgkbl"
                            frameBorder="0"
                            allowFullScreen
                            style={{
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                width: '100%',
                                height: '100%',
                            }}
                        ></iframe>
                    </div>
                </div>
            </div>

            {/* Notable Shows Section */}
            <div className="space-y-4">
                <h2 className="text-2xl md:text-3xl font-bold uppercase text-primary">Notable Shows</h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {cardData.map((card, index) => (
                        <div
                            key={index}
                            className="bg-card rounded overflow-hidden flex flex-col hover:shadow-lg transition-shadow"
                        >
                            <img
                                src={getCloudinaryUrl(card.image, {
                                    width: 600,
                                    height: 400,
                                    crop: 'fill',
                                    quality: 'auto',
                                })}
                                alt={card.content}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-4 flex-grow flex flex-col justify-end">
                                {card.title && <p className="text-foreground text-sm mb-2">{card.title}</p>}
                                <p className="text-foreground font-bold">{card.content}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
